var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.071,
    height: 10.071,
    x: 1.484,
    y: 4.944,
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 1.2,
    rx: 1.778
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 1.2,
    d: "M4.15 2.945s0-1.111 2.072-1.112h5.05c1.096 0 1.644 0 2.053.234.277.158.506.387.663.663.234.41.234.958.234 2.054v4.605c0 2.516-.889 2.516-.889 2.516"
  })));
};
export default SvgCopy;